import React from 'react';
import s from './s.module.less';
import dayjs from 'dayjs';
import UserAddIcon from 'assets/prospects/user.svg';
import { getTimeStr } from 'utils/calendar';
import AddAndUpdateProspects from 'components/AddAndUpdateProspects';
import { EStatus, EProspectType, EOnBoardingStatus, Prospect, TProspectInsurance } from 'types/common';
import { getAgeFromBirthday, displayItem } from 'utils/common';
import CheckCircleIcon from 'assets/common/checkCircle.svg';
import UnCircleIcon from 'assets/common/unCheck.svg';
import { EMPTY_PLACEHOLDER_WITH_DASH } from 'constants/common';
import InboxNotes from 'components/InboxNotes';
import AppointmentList from 'components/AppointmentList';
import { Button, Modal, Tabs } from 'antd';

type Props = {
    showMoreInfo?: boolean,
    data?: Prospect,
    onUpdate: () => void,
    loading?: boolean,
    smallSize?: boolean,
};

const ProsepectInfo = (props: Props) => {
    const { data, onUpdate, loading = false, smallSize, showMoreInfo } = props;
    const [editType, setEditType] = React.useState<1 | 2>(1);
    const [showEdit, setShowEdit] = React.useState(false);
    const name = `${data?.firstName || ''} ${data?.lastName || ''}`;
    const [viewImgUrl, setViewImgUrl] = React.useState<string | undefined>();

    const isSample = data?.isSample;

    let patientPortal = 'Not sent';
    if (data?.onBoardingStatus === EOnBoardingStatus.SENT) {
        patientPortal = 'Sent';
    } else if (data?.onBoardingStatus === EOnBoardingStatus.COMPLETE) {
        patientPortal = 'Signed up';
    } else if (data?.onBoardingStatus === EOnBoardingStatus.IN_PROGRESS) {
        patientPortal = 'In progress';
    }

    const cNumber = data?.cardNum || data?.patientCardNum || '';
    const cCvc = data?.cardCvc || data?.patientCardCvc || '';
    const cExp = data?.cardExpirationDate || data?.patientCardExpirationDate || '';

    const insurance1: TProspectInsurance | undefined = data?.insurances && data.insurances.length > 0 ? data.insurances[0] : undefined;
    const insurance2: TProspectInsurance | undefined = data?.insurances && data.insurances.length > 1 ? data.insurances[1] : undefined;
    const secondInsurance = !!insurance2;

    return (
        <div className={`${s.wrap} ${smallSize ? s.wrapSmall : ''}`}>
            <div className={s.contentTop}>
                <div className={s.left}>
                    <h1 className={s.leftBtm}>
                        <div className={s.title}>
                            <div className={s.titleName}>
                                {
                                    isSample ? '[Sample]' : ''
                                }
                                {name}
                            </div>
                            {data?.type === EProspectType.PROSPECT && (
                                <span className={s.statusP}>
                                    Prospect
                                    {/* Client */}
                                </span>
                            )}
                            {data?.type === EProspectType.PATIENT && (
                                <span className={`${s.statusP} ${s.statusPatient}`}>
                                    Patient
                                </span>
                            )}
                            {
                                data?.onBoardingStatus === EOnBoardingStatus.COMPLETE && (
                                    <span className={`${s.statusP} ${s.statusProtect}`}>
                                        {smallSize ? 'Card on file' : 'Credit card on file'}
                                    </span>
                                )
                            }
                            {
                                data?.onBoardingStatus !== EOnBoardingStatus.COMPLETE && (
                                    <span className={`${s.statusP} ${s.statusUnProtect}`}>
                                        {smallSize ? 'Card pending' : 'Credit card pending'}
                                    </span>
                                )
                            }
                        </div>
                    </h1>
                </div>
            </div>
            <div className={s.contentMid}>
                <div className={s.contentItem}>
                    <img src={UserAddIcon} className={s.contentImg} />
                    <span className={s.contentItemValue}>
                        Created:{' '}
                        {getTimeStr(
                            dayjs(data?.createTime),
                            'MMM D, YYYY [at] HH:mm',
                        )}
                    </span>
                </div>
                {/* <div className={s.contentItem}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M6.66667 5.83333V2.5M13.3333 5.83333V2.5M5.83334 9.16667H14.1667M4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V5.83333C17.5 4.91286 16.7538 4.16667 15.8333 4.16667H4.16667C3.24619 4.16667 2.5 4.91286 2.5 5.83333V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span className={s.contentItemValue}>Appointment: 1</span>
                </div> */}
                <div className={s.contentItem}>
                    <img
                        src={
                            data?.status === EStatus.Active
                                ? CheckCircleIcon
                                : UnCircleIcon
                        }
                    />
                    <span className={s.contentItemValue}>{data?.status}</span>
                </div>
                <div className={s.contentItem} style={{ paddingLeft: '4px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                        <path d="M2.76753 13.8364C4.46056 12.8795 6.4165 12.3333 8.50001 12.3333C10.5835 12.3333 12.5395 12.8795 14.2325 13.8364M11 7.33333C11 8.71405 9.88072 9.83333 8.50001 9.83333C7.11929 9.83333 6 8.71405 6 7.33333C6 5.95262 7.11929 4.83333 8.50001 4.83333C9.88072 4.83333 11 5.95262 11 7.33333ZM16 9C16 13.1421 12.6421 16.5 8.50001 16.5C4.35787 16.5 1 13.1421 1 9C1 4.85786 4.35787 1.5 8.50001 1.5C12.6421 1.5 16 4.85786 16 9Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className={s.contentItemValue}>
                        Patient portal: {patientPortal}
                    </span>
                </div>
            </div>
            <Tabs
                activeKey={`${editType}`}
                onChange={(key) => {
                    setEditType(parseInt(key, 10) as 1 | 2);
                }}
                items={[
                    {
                        label: 'Client Info',
                        key: '1',
                        children: (
                            <div className={s.infoWrap}>
                                <div>
                                    {
                                        !isSample &&
                                        <Button
                                            onClick={() => {
                                                setEditType(1);
                                                setShowEdit(true);
                                            }}
                                        >
                                            <div className={s.btnWrap}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.5118 2.48816L14.0421 1.95783L14.0421 1.95783L13.5118 2.48816ZM4.33333 14.0237V14.7737C4.53225 14.7737 4.72301 14.6946 4.86366 14.554L4.33333 14.0237ZM2 14.0237H1.25C1.25 14.4379 1.58579 14.7737 2 14.7737V14.0237ZM2 11.6429L1.46967 11.1126C1.32902 11.2533 1.25 11.444 1.25 11.6429H2ZM11.1548 2.48816L11.6851 3.01849C12.0431 2.6605 12.6235 2.6605 12.9815 3.01849L13.5118 2.48816L14.0421 1.95783C13.0984 1.01406 11.5682 1.01406 10.6245 1.95783L11.1548 2.48816ZM13.5118 2.48816L12.9815 3.01849C13.3395 3.37647 13.3395 3.95687 12.9815 4.31485L13.5118 4.84518L14.0421 5.37551C14.9859 4.43174 14.9859 2.90159 14.0421 1.95783L13.5118 2.48816ZM13.5118 4.84518L12.9815 4.31485L3.803 13.4933L4.33333 14.0237L4.86366 14.554L14.0421 5.37551L13.5118 4.84518ZM4.33333 14.0237V13.2737H2V14.0237V14.7737H4.33333V14.0237ZM11.1548 2.48816L10.6245 1.95783L1.46967 11.1126L2 11.6429L2.53033 12.1733L11.6851 3.01849L11.1548 2.48816ZM2 11.6429H1.25V14.0237H2H2.75V11.6429H2ZM10.1548 3.48816L9.62445 4.01849L11.9815 6.37551L12.5118 5.84518L13.0421 5.31485L10.6851 2.95783L10.1548 3.48816Z" fill="#6B7280" />
                                                </svg>
                                                Edit
                                            </div>
                                        </Button>
                                    }
                                </div>
                                <div className={s.row}>
                                    <div
                                        style={{
                                            width: '300px',
                                        }}
                                        className={s.displayItem}
                                    >
                                        <div className={s.label}>Email</div>
                                        <div className={s.value}>{data?.email}</div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Phone number</div>
                                        <div className={s.value}>
                                            {displayItem(
                                                loading,
                                                EMPTY_PLACEHOLDER_WITH_DASH,
                                                data?.tel,
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Address</div>
                                        <div className={s.value}>
                                            {displayItem(
                                                loading,
                                                EMPTY_PLACEHOLDER_WITH_DASH,
                                                `${data?.address ? data?.address : ''}${data?.city ? `, ${data?.city}` : ''
                                                }${data?.state ? `, ${data?.state}` : ''}${data?.zip ? `, ${data?.zip}` : ''
                                                }`,
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Age</div>
                                        <div className={s.value}>
                                            {displayItem(
                                                loading,
                                                EMPTY_PLACEHOLDER_WITH_DASH,
                                                getAgeFromBirthday(data?.birthday),
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Birthday</div>
                                        <div className={s.value}>
                                            {/* January, 01, 2002 */}
                                            {data?.birthday
                                                ? getTimeStr(dayjs(data?.birthday), 'MMMM, DD, YYYY')
                                                : displayItem(loading, EMPTY_PLACEHOLDER_WITH_DASH, '')}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Gender</div>
                                        <div className={s.value}>
                                            {data?.gender
                                                ? data?.gender
                                                : displayItem(loading, EMPTY_PLACEHOLDER_WITH_DASH, '')}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Preferred methods of contact</div>
                                        <div className={s.value}>
                                            {data?.preferMethod
                                                ? data?.preferMethod?.split(',').join(', ')
                                                : displayItem(loading, EMPTY_PLACEHOLDER_WITH_DASH, '')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                    },
                    {
                        label: 'Insurance & payment',
                        key: '2',
                        children: (
                            <div className={s.infoWrap}>
                                <div>
                                    {
                                        !isSample &&
                                        <Button
                                            onClick={() => {
                                                setEditType(2);
                                                setShowEdit(true);
                                            }}
                                        >
                                            <div className={s.btnWrap}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.5118 2.48816L14.0421 1.95783L14.0421 1.95783L13.5118 2.48816ZM4.33333 14.0237V14.7737C4.53225 14.7737 4.72301 14.6946 4.86366 14.554L4.33333 14.0237ZM2 14.0237H1.25C1.25 14.4379 1.58579 14.7737 2 14.7737V14.0237ZM2 11.6429L1.46967 11.1126C1.32902 11.2533 1.25 11.444 1.25 11.6429H2ZM11.1548 2.48816L11.6851 3.01849C12.0431 2.6605 12.6235 2.6605 12.9815 3.01849L13.5118 2.48816L14.0421 1.95783C13.0984 1.01406 11.5682 1.01406 10.6245 1.95783L11.1548 2.48816ZM13.5118 2.48816L12.9815 3.01849C13.3395 3.37647 13.3395 3.95687 12.9815 4.31485L13.5118 4.84518L14.0421 5.37551C14.9859 4.43174 14.9859 2.90159 14.0421 1.95783L13.5118 2.48816ZM13.5118 4.84518L12.9815 4.31485L3.803 13.4933L4.33333 14.0237L4.86366 14.554L14.0421 5.37551L13.5118 4.84518ZM4.33333 14.0237V13.2737H2V14.0237V14.7737H4.33333V14.0237ZM11.1548 2.48816L10.6245 1.95783L1.46967 11.1126L2 11.6429L2.53033 12.1733L11.6851 3.01849L11.1548 2.48816ZM2 11.6429H1.25V14.0237H2H2.75V11.6429H2ZM10.1548 3.48816L9.62445 4.01849L11.9815 6.37551L12.5118 5.84518L13.0421 5.31485L10.6851 2.95783L10.1548 3.48816Z" fill="#6B7280" />
                                                </svg>
                                                Edit
                                            </div>
                                        </Button>
                                    }
                                </div>
                                <div className={s.itemTitle}>{secondInsurance ? 'Primary insurance' : 'Insurance'}</div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Member legal first name</div>
                                        <div className={s.value}>
                                            {insurance1?.firstName || '-'}
                                        </div>
                                    </div>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Member legal last name</div>
                                        <div className={s.value}>
                                            {insurance1?.lastName || '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Insurance carrier</div>
                                        <div className={s.value}>
                                            {insurance1?.carrier || '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Insurance plan</div>
                                        <div className={s.value}>
                                            {insurance1?.plan || '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem} style={{ width: '150px' }}>
                                        <div className={s.label}>Member ID</div>
                                        <div className={s.value}>
                                            {insurance1?.memberId || '-'}
                                        </div>
                                    </div>
                                    <div className={s.displayItem} style={{ width: '150px' }}>
                                        <div className={s.label}>Group ID</div>
                                        <div className={s.value}>
                                            {insurance1?.groupId || '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Front of insurance card</div>
                                        {
                                            insurance1?.front &&
                                            <div className={s.value}>
                                                <img src={insurance1?.front} className={s.insurImg} />
                                                <span
                                                    onClick={() => {
                                                        setViewImgUrl(insurance1?.front || undefined);
                                                    }}
                                                    className={s.viewImg}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M2.33398 4.66634V2.33301M2.33398 2.33301H4.66732M2.33398 2.33301L5.25065 5.24967M11.6673 4.66634V2.33301M11.6673 2.33301H9.33398M11.6673 2.33301L8.75065 5.24967M2.33398 9.33301V11.6663M2.33398 11.6663H4.66732M2.33398 11.6663L5.25065 8.74967M11.6673 11.6663L8.75065 8.74967M11.6673 11.6663V9.33301M11.6673 11.6663H9.33398" stroke="#00816B" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                    <div className={s.displayItem}>
                                        <div className={s.label}>Back of insurance card</div>
                                        {
                                            insurance1?.backend &&
                                            <div className={s.value}>
                                                <img src={insurance1?.backend} className={s.insurImg} />
                                                <span
                                                    onClick={() => {
                                                        setViewImgUrl(insurance1?.backend || undefined);
                                                    }}
                                                    className={s.viewImg}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M2.33398 4.66634V2.33301M2.33398 2.33301H4.66732M2.33398 2.33301L5.25065 5.24967M11.6673 4.66634V2.33301M11.6673 2.33301H9.33398M11.6673 2.33301L8.75065 5.24967M2.33398 9.33301V11.6663M2.33398 11.6663H4.66732M2.33398 11.6663L5.25065 8.74967M11.6673 11.6663L8.75065 8.74967M11.6673 11.6663V9.33301M11.6673 11.6663H9.33398" stroke="#00816B" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    secondInsurance && (
                                        <>
                                            <div className={s.itemTitle}>Secondary insurance</div>
                                            <div className={s.row}>
                                                <div className={s.displayItem}>
                                                    <div className={s.label}>Insurance carrier</div>
                                                    <div className={s.value}>
                                                        {insurance2?.carrier || '-'}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={s.row}>
                                                <div className={s.displayItem} style={{ width: '150px' }}>
                                                    <div className={s.label}>Member ID</div>
                                                    <div className={s.value}>
                                                        {insurance2?.memberId || '-'}
                                                    </div>
                                                </div>
                                                <div className={s.displayItem} style={{ width: '150px' }}>
                                                    <div className={s.label}>Group ID</div>
                                                    <div className={s.value}>
                                                        {insurance2?.groupId || '-'}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }

                                <div className={s.itemTitle}>Payment</div>
                                <div className={s.row}>
                                    <div className={s.displayItem} style={{ width: '200px' }}>
                                        <div className={s.label}>Card number</div>
                                        <div className={s.value}>
                                            {cNumber || '-'}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.displayItem} style={{ width: '200px' }}>
                                        <div className={s.label}>Expiration date</div>
                                        <div className={s.value}>
                                            {cExp || '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                    },
                ]}
            />

            {showEdit && (
                <AddAndUpdateProspects
                    item={data}
                    show={showEdit}
                    onSuccess={() => {
                        onUpdate();
                        setShowEdit(false);
                    }}
                    onCannel={() => {
                        setShowEdit(false);
                    }}
                    type={editType}
                />
            )}
            {
                showMoreInfo && (
                    <AppointmentList
                        title="Appointments"
                        prospect={data}
                    />
                )
            }
            {showMoreInfo && <InboxNotes prospect={data} />}
            <Modal
                open={!!viewImgUrl}
                width={600}
                onCancel={() => {
                    setViewImgUrl(undefined);
                }}
                onOk={() => {
                    setViewImgUrl(undefined);
                }}
                footer={null}
            >
                <img className={s.viewImgModal} src={viewImgUrl} />
            </Modal>
        </div>
    );
};

export default ProsepectInfo;
